import React, { useEffect, useState } from "react";
import BRAND from "../brand";

// Install helper for the kiosk / display. Hidden from the public: it only appears when the
// address has ?install=1, which whoever sets the screen up uses once on that device.

const wantedAtLoad = typeof window !== "undefined" && new URLSearchParams(window.location.search).get("install") === "1";
let deferred = null; // the browser fires the install event early, often before this component mounts
const listeners = new Set();
if (wantedAtLoad) {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; listeners.forEach((f) => f(e)); });
}

export default function PwaInstallBar({ what = "screen" }) {
  const wanted = wantedAtLoad;
  const [prompt, setPrompt] = useState(deferred);
  const [done, setDone] = useState(false);
  const standalone = typeof window !== "undefined" && (window.matchMedia?.("(display-mode: standalone)").matches || window.matchMedia?.("(display-mode: fullscreen)").matches);

  useEffect(() => {
    if (!wanted) return undefined;
    const onInstalled = () => setDone(true);
    listeners.add(setPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => { listeners.delete(setPrompt); window.removeEventListener("appinstalled", onInstalled); };
  }, [wanted]);

  if (!wanted) return null;

  let body;
  if (standalone || done) body = <span>This {what} is installed as an app. Open it from the desktop or the apps list.</span>;
  else if (prompt) {
    body = (
      <>
        <span>Install this {what} as an app (opens full screen, no browser bars).</span>
        <button style={S.btn} onClick={async () => { prompt.prompt(); try { await prompt.userChoice; } catch (e) { /* closed */ } setPrompt(null); }}>Install</button>
      </>
    );
  } else body = <span>To install: open the browser menu and choose <b>Install app</b> (Chrome / Edge) or <b>Add to Home Screen</b> (Android / iPad: Share, then Add to Home Screen).</span>;

  return <div style={S.bar}>{body}<button style={S.close} onClick={() => { const u = new URL(window.location.href); u.searchParams.delete("install"); window.location.replace(u.toString()); }}>Done</button></div>;
}

const S = {
  bar: { position: "fixed", left: "50%", bottom: 18, transform: "translateX(-50%)", zIndex: 100000, display: "flex", alignItems: "center", gap: 14, maxWidth: "92vw", background: "#0F1E3D", color: "#fff", borderRadius: 14, padding: "12px 18px", fontSize: 14, boxShadow: "0 10px 34px rgba(0,0,0,0.35)", fontFamily: "'DM Sans','Segoe UI',sans-serif" },
  btn: { background: BRAND.colorPrimary, color: "#fff", border: "none", borderRadius: 10, padding: "8px 16px", fontSize: 14, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" },
  close: { background: "transparent", color: "#9FB3C8", border: "1px solid #3A4B66", borderRadius: 10, padding: "6px 12px", fontSize: 12, cursor: "pointer", fontFamily: "inherit" },
};
